<template>
  <div class="page_wraps">
    <div class="page_fle">
      <div>Frontseat服务全球XXX位商家</div>
      <div>和XXX品牌建立深度合作</div>
      <div>累计XXXX位用户使用</div>
    </div>
    <div>
      <div class="act_tetx">研究案例</div>
      <div class="page_ve">
        <div :class="['page_de', act == 1 ? 'act' : '']" @click="pageTab(1)">全部</div>
        <div :class="['page_de', act == 2 ? 'act' : '']" @click="pageTab(2)">包包</div>
        <div :class="['page_de', act == 3 ? 'act' : '']" @click="pageTab(3)">箱包</div>
      </div>

      <div class="page_flexs">
        <div class="page_text_d">
          <div class="page_ie">
            <div class="dev_t"></div>
            <div class="dev_d">xxxx标题</div>
            <div
              class="dev_x"
            >xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域</div>
          </div>
        </div>
        <div class="page_text_d">
          <div class="page_ie">
            <div class="dev_t"></div>
            <div class="dev_d">xxxx标题</div>
            <div
              class="dev_x"
            >xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域</div>
          </div>
        </div>
        <div class="page_text_d">
          <div class="page_ie">
            <div class="dev_t"></div>
            <div class="dev_d">xxxx标题</div>
            <div
              class="dev_x"
            >xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域</div>
          </div>
        </div>
        <div class="page_text_d">
          <div class="page_ie">
            <div class="dev_t"></div>
            <div class="dev_d">xxxx标题</div>
            <div
              class="dev_x"
            >xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域</div>
          </div>
        </div>
        <div class="page_text_d">
          <div class="page_ie">
            <div class="dev_t"></div>
            <div class="dev_d">xxxx标题</div>
            <div
              class="dev_x"
            >xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域</div>
          </div>
        </div>
        <div class="page_text_d">
          <div class="page_ie">
            <div class="dev_t"></div>
            <div class="dev_d">xxxx标题</div>
            <div
              class="dev_x"
            >xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域xx内容区域</div>
          </div>
        </div>
      </div>
    </div>
    <div class="page_sole"></div>
    <div style="width: 100%;">
      <el-pagination :page-size="6" :pager-count="11" layout="prev, pager, next" :total="1000"></el-pagination>
    </div>
    <div class="page_sole2"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      act: 1
    };
  },
  methods: {
    pageTab(val) {
      this.act = val;
    }
  }
};
</script>

<style scoped>
.page_wraps {
  padding: 5rem;
}

.page_fle {
  width: 100%;
  padding-bottom: 9.38rem;
  padding-top: 5.88rem;
  border-bottom: 0.2rem solid #d8d8d8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 4.25rem;
  color: #222;
  line-height: 5.9rem;
}

.act_tetx {
  color: #131316;
  font-size: 3.125rem;
  margin-top: 6.875rem;
}

.page_ve {
  width: 100%;
  display: flex;
  /* align-items: center; */
}

.page_de {
  color: #222222;
  font-size: 1.75rem;
  margin: 2.2rem 0;
  margin-right: 6.2rem;
}

.act {
  color: #e2bf6b;
}

.page_flexs {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  align-content: center;
}

.page_fl {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.page_text_d {
  width: 24.56rem;
  height: 74.5rem;
  border: 1px solid #979797;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 1rem;
  margin-bottom: 1.6rem;
}

.page_ie {
  padding: 0 2.2rem;
}

.dev_t {
  width: 19.82rem;
  height: 13.4rem;
  background-color: #d8d8d8;
  margin-top: 3.125rem;
}

.dev_d {
  color: #222222;
  font-size: 3.25rem;
  margin-top: 2.37rem;
}

.dev_x {
  font-size: 2.2rem;
  margin-top: 1.75rem;
  color: #222222;
  word-wrap: break-word;
  line-height: 3rem;
}
.el-pagination {
  color: #333; /* 你想要的颜色 */
}
.page_sole{
    width: 100%;
    background-color: #D8D8D8;
    height: 0.1rem;
    margin-top: 4rem;
    margin-bottom: 1.4rem;
}
.page_sole2{
    width: 100%;
    background-color: #D8D8D8;
    height: 0.1rem;
    margin-top: 1.4rem;
}
</style>